import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "tw-mt-[50px]" }, " Congratulations you completed this activity. You can choose to practice the words again or test yourself. ", -1)
const _hoisted_3 = { class: "tw-text-main1" }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "tw-mt-[50px]" }, " You have completed your test. Please enter your name. ", -1)
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = {
  key: 2,
  class: "tw-text-danger"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "sf-btn-primary",
    type: "submit"
  }, "Set Name")
], -1)
const _hoisted_10 = { class: "tw-text-main1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MobileKeyboard = _resolveComponent("MobileKeyboard")!

  return (_ctx.step == 'practiceComplete')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.spellingPoints) + " points would have been sent to your account if you were logged in. ", 1),
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            class: "sf-btn-primary",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('close')), ["prevent"]))
          }, " Close ")
        ])
      ]))
    : (_ctx.step == 'nameForm')
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("form", {
            onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.setName && _ctx.setName(...args)), ["prevent"]))
          }, [
            (_ctx.isMobile)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.customName), 1))
              : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _withDirectives(_createElementVNode("input", {
                    ref: "setNameField",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.customName) = $event)),
                    type: "text",
                    class: "tw-border tw-border-solid tw-border-primary tw-p-[10px] tw-py-[10px] tw-my-[20px] tw-outline-none"
                  }, null, 512), [
                    [_vModelText, _ctx.customName]
                  ])
                ])),
            (_ctx.customNameError)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, " Please enter a valid name "))
              : _createCommentVNode("", true),
            _hoisted_9,
            _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.spellingPoints) + " points would have been sent to your account if you were logged in. ", 1),
            (_ctx.isMobile)
              ? (_openBlock(), _createBlock(_component_MobileKeyboard, {
                  key: 3,
                  modelValue: _ctx.customName,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.customName) = $event))
                }, null, 8, ["modelValue"]))
              : _createCommentVNode("", true)
          ], 32)
        ]))
      : _createCommentVNode("", true)
}